import {Moment} from 'moment';
import {IIcePhenomena} from './kn15-parse.service';

const template = require<string>('./ice-phenomena-card.html');

export interface IIcePhenomenaCardData {
  date: Moment;
  icePhenomenae: IIcePhenomena[];
  disabledDischarge: boolean;
}

const icePhenomenaCardComponent: ng.IComponentOptions = {
  bindings: {
    cardData: '<',
    dischargeOptionEnabled: '<',
    onDischargeDisabled: '&',
    index: '<'
  },
  template
};
export default icePhenomenaCardComponent;



/** WEBPACK FOOTER **
 ** ./app/operational/input/kn15-telegram/ice-phenomena-card.component.ts
 **/